<template>
  <section>
    <!--工具条-->
    <toolbar :buttonList="buttonList" @callFunction="callFunction"></toolbar>

    <!--列表-->
    <el-table
      :data="list"
      v-loading="listLoading"
      row-key="id"
      border
      lazy
      :load="load"
      :tree-props="{ children: 'children', hasChildren: 'hasChildren' }"
      style="width: 100%"
      ref="table"
      @select="dialogCheck"
      @row-click="selectCurrentRow"
      class="custom-tbl"
    >
      <el-table-column type="selection" :min-width="5"></el-table-column>
      <el-table-column label="字典值" min-width="25" show-overflow-tooltip>
        <template slot-scope="scope">
          <i class="fa" :class="scope.row.icon"></i>{{ scope.row.value }}
        </template>
      </el-table-column>
      <el-table-column
        prop="code"
        label="字典编码"
        min-width="20"
        show-overflow-tooltip
      ></el-table-column>
      <el-table-column
        prop="message"
        label="描述"
        min-width="20"
        show-overflow-tooltip
      ></el-table-column>
      <el-table-column
        prop="order"
        label="排序"
        min-width="10"
      ></el-table-column>
    </el-table>

    <!--工具条-->
    <el-col :span="24" class="toolbar">
      <el-pagination
        layout="prev, pager, next"
        @current-change="handleCurrentChange"
        :page-size="50"
        :total="total"
        style="float: right"
      ></el-pagination>
    </el-col>

    <!--编辑界面-->
    <el-dialog
      title="编辑"
      :visible.sync="editFormVisible"
      v-model="editFormVisible"
      :close-on-click-modal="false"
    >
      <el-form
        :model="editForm"
        label-width="80px"
        :rules="editFormRules"
        ref="editForm"
      >
        <el-row>
          <el-col :span="12">
            <el-form-item label="字典编码" prop="code">
              <el-input v-model="editForm.code" auto-complete="off"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="字典值" prop="value">
              <el-input v-model="editForm.value" auto-complete="off"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="12">
            <el-form-item
              prop="pKeyArr"
              v-if="options && options.length > 0"
              label="父级字典"
              width
              sortable
            >
              <el-cascader
                placeholder="请选择，支持搜索功能"
                style="width: 100%"
                v-model="editForm.pKeyArr"
                :options="options"
                filterable
                clearable
                :key="isResouceShow"
                :props="{ checkStrictly: true, expandTrigger: 'hover' }"
                v-if="!editLoading"
              ></el-cascader>
              <el-cascader
                placeholder="加载中..."
                style="width: 100%"
                v-if="editLoading"
              ></el-cascader>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="排序" prop="order">
              <el-input v-model="editForm.order" auto-complete="off"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="24">
            <el-form-item label="描述" prop="message">
              <el-input
                v-model="editForm.message"
                auto-complete="off"
              ></el-input>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click.native="editFormVisible = false">取消</el-button>
        <el-button
          type="primary"
          @click.native="editSubmit"
          :loading="editLoading"
          >提交</el-button
        >
      </div>
    </el-dialog>

    <!--新增界面-->
    <el-dialog
      title="新增"
      :visible.sync="addFormVisible"
      v-model="addFormVisible"
      :close-on-click-modal="false"
    >
      <el-form
        :model="addForm"
        label-width="80px"
        :rules="addFormRules"
        ref="addForm"
      >
        <el-row>
          <el-col :span="12">
            <el-form-item label="字典编码" prop="code">
              <el-input v-model="addForm.code" auto-complete="off"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="字典值" prop="value">
              <el-input v-model="addForm.value" auto-complete="off"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="12">
            <el-form-item
              prop="pKeyArr"
              v-if="options && options.length > 0"
              label="父级字典"
              width
              sortable
            >
              <el-cascader
                placeholder="请选择，支持搜索功能"
                style="width: 100%"
                v-model="addForm.pKeyArr"
                :options="options"
                filterable
                clearable
                :key="isResouceShow"
                :props="{ checkStrictly: true, expandTrigger: 'hover' }"
                v-if="!editLoading"
              ></el-cascader>
              <el-cascader
                placeholder="加载中..."
                style="width: 100%"
                v-if="editLoading"
              ></el-cascader>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="排序" prop="order">
              <el-input v-model="addForm.order" auto-complete="off"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="24">
            <el-form-item label="描述" prop="message">
              <el-input
                v-model="addForm.message"
                auto-complete="off"
              ></el-input>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click.native="addFormVisible = false">取消</el-button>
        <el-button
          type="primary"
          @click.native="addSubmit"
          :loading="addLoading"
          >提交</el-button
        >
      </div>
    </el-dialog>
  </section>
</template>

<script>
import util from "../../../util/date";
import {
  getDictionaryTreeTable,
  removeDictionary,
  saveDictionary,
  getDictionaryTree,
} from "../../api/api";
import { getButtonList } from "../../promissionRouter";
import Toolbar from "../../components/Toolbar";

export default {
  components: { Toolbar },
  data() {
    return {
      buttonList: [],
      currentRow: null,
      options: [],
      filter: {
        key: "",
      },
      list: [],
      total: 0,
      page: 1,
      listLoading: false,
      sels: [], //列表选中列

      addDialogFormVisible: false,
      editFormVisible: false, //编辑界面是否显示
      editLoading: false,
      editFormRules: {
        value: [{ required: true, message: "请输入字典值", trigger: "blur" }],
        code: [{ required: true, message: "请输入字典编码", trigger: "blur" }],
      },
      //编辑界面数据
      editForm: {
        id: 0,
        order: 0,
        pKeyArr: [],
        code: "",
        value: "",
        message: "",
        icon: "",
      },

      addFormVisible: false, //新增界面是否显示
      addLoading: false,
      addCodeDisabled: false,
      editCodeDisabled: false,
      addFormRules: {
        value: [{ required: true, message: "请输入字典值", trigger: "blur" }],
        code: [{ required: true, message: "请输入字典编码", trigger: "blur" }],
      },
      //新增界面数据
      addForm: {
        id: 0,
        order: 0,
        pKeyArr: [],
        code: "",
        value: "",
        message: "",
        icon: "",
      },
      isResouceShow: 0,
    };
  },
  methods: {
    dialogCheck(selection, row) {
      this.currentRow = null;
      this.$refs.table.clearSelection();
      if (selection.length === 0) {
        return;
      }
      if (row) {
        this.selectCurrentRow(row);
      }
    },
    selectCurrentRow(val) {
      if (val) {
        this.currentRow = val;
        this.$refs.table.clearSelection();
        this.$refs.table.toggleRowSelection(val, true);
      }
    },
    callFunction(item) {
      this.filter.key = item.search;
      this[item.func].apply(this, item);
    },
    handleCurrentChange(val) {
      this.page = val;
      this.handleQuery();
    },
    load(tree, treeNode, resolve) {
      let para = {
        pKey: tree.key,
        key: this.filter.key,
      };
      getDictionaryTreeTable(para).then((res) => {
        resolve(res.data.response);
      });
    },
    handleQuery() {
      let para = {
        key: this.filter.key,
      };
      this.listLoading = true;

      //NProgress.start();
      getDictionaryTreeTable(para).then((res) => {
        this.list = res.data.response;
        this.listLoading = false;
        //NProgress.done();
      });
    },
    //删除
    handleDel() {
      let row = this.currentRow;
      if (!row) {
        this.$message({
          message: "请选择要删除的一行数据！",
          type: "error",
        });

        return;
      }
      this.$confirm("确认删除该记录吗?", "提示", {
        type: "warning",
      })
        .then(() => {
          this.listLoading = true;
          //NProgress.start();
          let para = { id: row.id };
          removeDictionary(para).then((res) => {
            if (util.isEmt.format(res)) {
              this.listLoading = false;
              return;
            }
            this.listLoading = false;
            //NProgress.done();
            if (res.data.isSuccess) {
              this.$message({
                message: "删除成功",
                type: "success",
              });
            } else {
              this.$message({
                message: res.data.msg,
                type: "error",
              });
            }

            this.handleQuery();
          });
        })
        .catch(() => {});
    },
    //显示编辑界面
    handleEdit() {
      let row = this.currentRow;
      if (!row) {
        this.$message({
          message: "请选择要编辑的一行数据！",
          type: "error",
        });

        return;
      }
      let that = this;

      that.options = [];

      this.editForm = {};
      that.editLoading = true;
      that.editFormVisible = true;
      that.editCodeDisabled = false;
      let para = { pid: row.id };
      getDictionaryTree(para).then((res) => {
        ++that.isResouceShow;
        this.options.push(res.data.response);
        that.editForm = Object.assign({}, row);
        that.editLoading = false;
      });
    },
    //显示新增界面
    handleAdd() {
      this.options = [];
      this.addFormVisible = true;
      this.addLoading = true;
      this.addForm = {
        id: 0,
        order: 0,
        pKeyArr: [],
        code: "",
        value: "",
        message: "",
        icon: "",
      };
      getDictionaryTree({}).then((res) => {
        ++this.isResouceShow;
        this.options.push(res.data.response);
        this.addLoading = false;
      });
    },
    //编辑
    editSubmit: function () {
      this.$refs.editForm.validate((valid) => {
        if (valid) {
          this.$confirm("确认提交吗？", "提示", {}).then(() => {
            this.editLoading = true;
            //NProgress.start();
            let para = Object.assign({}, this.editForm);

            para.pKey = para.pKeyArr[para.pKeyArr.length - 1];
            if (para.key == para.pKey) {
              this.$message({
                message: "警告，父节点不能是自己！",
                type: "error",
              });
              this.editLoading = false;
              return;
            }

            saveDictionary(para).then((res) => {
              if (util.isEmt.format(res)) {
                this.editLoading = false;
                return;
              }
              this.editLoading = false;
              if (res.data.isSuccess) {
                this.editLoading = false;
                //NProgress.done();
                this.$message({
                  message: res.data.msg,
                  type: "success",
                });
                this.$refs["editForm"].resetFields();
                this.$refs.table.setCurrentRow();
                this.editFormVisible = false;
                this.handleQuery();
              } else {
                this.$message({
                  message: res.data.msg,
                  type: "error",
                });
              }
            });
          });
        }
      });
    },
    //新增
    addSubmit: function () {
      let _this = this;
      this.$refs.addForm.validate((valid) => {
        if (valid) {
          this.$confirm("确认提交吗？", "提示", {}).then(() => {
            this.addLoading = true;
            //NProgress.start();
            let para = Object.assign({}, this.addForm);
            para.pKey = para.pKeyArr[para.pKeyArr.length - 1];
            saveDictionary(para).then((res) => {
              if (util.isEmt.format(res)) {
                this.addLoading = false;
                return;
              }
              this.addLoading = false;
              if (res.data.isSuccess) {
                this.addLoading = false;
                //NProgress.done();
                this.$message({
                  message: res.data.msg,
                  type: "success",
                });
                this.$refs["addForm"].resetFields();
                this.options = [];
                this.$refs.table.setCurrentRow();
                this.addFormVisible = false;
                this.handleQuery();
              } else {
                this.$message({
                  message: res.data.msg,
                  type: "error",
                });
              }
            });
          });
        }
      });
    },
  },
  mounted() {
    this.handleQuery();
    let routers = window.localStorage.router
      ? JSON.parse(window.localStorage.router)
      : [];
    this.buttonList = getButtonList(this.$route.path, routers);
  },
};
</script>

<style scoped>
.custom-tbl /deep/ .has-gutter .el-checkbox {
  display: none;
}
</style>
